var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgendaActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 1.16797H2.50065C2.05862 1.16797 1.6347 1.34356 1.32214 1.65612C1.00958 1.96868 0.833984 2.39261 0.833984 2.83464V16.168C0.833984 16.61 1.00958 17.0339 1.32214 17.3465C1.6347 17.659 2.05862 17.8346 2.50065 17.8346H12.5007C12.9427 17.8346 13.3666 17.659 13.6792 17.3465C13.9917 17.0339 14.1673 16.61 14.1673 16.168V7.0013M8.33398 1.16797L14.1673 7.0013M8.33398 1.16797V7.0013H14.1673",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaActive);
export default __webpack_public_path__ + "static/media/agenda-active.7699b8fcbd3b412d6d8a8583e1a3a3fb.svg";
export { ForwardRef as ReactComponent };